<template>
  <div class="weiVCon videoD">
     <router-link to="/runB">
    <img src="../assets/imgs/pxBanner.png" alt="" class="pxBanner">
     </router-link>
    <div class="trainListBox">
      <div class="trainLists">
        <ul class="clearfix">
          <li @click="toPage(0)" >
            <img
                src="../assets/imgs/px1.png"
                alt=""
              />
          </li>
          <li @click="toPage(2)" >
            <img
                src="../assets/imgs/px2.png"
                alt=""
              />
          </li>
          <li @click="toPage(1)" >
            <img
                src="../assets/imgs/px6.png"
                alt=""
              />
          </li>
          <li @click="toPage(3)" >
            <img
                src="../assets/imgs/px4.png"
                alt=""
              />
          </li>
           <li @click="toPage(4)" >
            <img
                src="../assets/imgs/px5.png"
                alt=""
              />
          </li>
        </ul>
      </div>
      <!-- <div v-if="!isLogin">
        <router-link to="/login">
          <img
            src="../assets/imgs/toLoginIcon.png"
            alt=""
            class="toLoginIcon"
          >

          <img
            src="../assets/imgs/nonLoginTxt.png"
            alt=""
            class="nonLoginTxt"
          >
        </router-link>
      </div> -->
      <!-- <div v-if="isLogin"> -->
        <!-- <div
          class="trainItems"
          v-for="item in classlist"
          :key="item.index"
        >
          <div class="clearfix">
            <div class="fl">
              <div class="trainTit">
                <img
                  src="../assets/imgs/huangg.png"
                  alt=""
                >
                {{item.title}}
              </div>
              <p>{{item.remark}}</p>
              <p v-if="item.isPay === 1">学习进度：{{item.mPer}}%（{{item.mNotLearn}}/{{item.mBasicsLearn}}分钟）</p>
              <div
                class="hasBuy isBuy"
                v-if="item.isPay === 1"
              >
                <img
                  src="../assets/imgs/sure.png"
                  alt=""
                >
                已购买<span>（有效期至{{item.expDate!=="" && item.expDate!==null?item.expDate:""}}）</span>
              </div>
              <div
                class="nonBuy isBuy"
                v-else
              >
                <img
                  src="../assets/imgs/money.png"
                  alt=""
                >
                {{item.money}}
              </div>
            </div>
            <div class="fr">
              <mt-button
                v-if="item.isPay===1"
                type="default"
                class="trainBtn btnStudy"
                @click="toCourseList(item.year,5)"
              >去学习</mt-button>
              <router-link
                v-else
                to="/pay"
                class="trainBtn btnStudy"
              >去购买</router-link>
            </div>
          </div>
        </div> -->
        <!-- <div class="trainItems">
          <div class="clearfix">
            <div class="fl">
              <div class="trainTit">
                <img
                  src="../assets/imgs/huangg.png"
                  alt=""
                >
                巡游出租车驾驶员继续教育
              </div>
              <p>海量资源包 随时随地可观看 名师讲解</p>
              <div class="nonBuy isBuy">
                <img
                  src="../assets/imgs/money.png"
                  alt=""
                >
                {{payMoney}}
              </div>
            </div>
            <div class="fr">
              <mt-button
                type="default"
                class="trainBtn btnBuy"
              >去购买</mt-button>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
    </div>
    <van-popup v-model="needwsBox" position="bottom">
      <van-picker
      show-toolbar
      title="请选择企业"
      :columns="cityList"
      @cancel="onCancel"
      @confirm="onConfirm"
    />
    </van-popup>
    <tabbar></tabbar>
  </div>
</template>
<style scoped>
.weiVCon{
  padding:0.2rem 0.3rem;
}
.pxBanner{
  width: 100%;
  height: auto;
  margin-bottom: 0.2rem;
}
  .van-radio-group {
      display: flex;
    justify-content: space-around;
    padding: 20px;
}
.van-hairline--top-bottom{
  margin: 20px 20px 20px 0;
}
.trainLists ul{
  margin-right: -0.12rem;
   margin-left: -0.08rem;
}
.trainLists ul li{
  margin-right: 0.1rem;
   margin-bottom: 0.1rem;
  float: left;
  width: 3.45rem;
  height: 1.52rem;
}
.trainLists ul li img{
  width: 100%;
  height: 100%;
}
</style>
<script>
import tabbar from '../components/tabbar.vue' // 引用组件的地址
import { Toast, Indicator } from 'mint-ui'
import { getTrainlist,needws,companyList,perfect } from '../../src/api/Api'
import { mapGetters } from 'vuex'
import { Popup } from 'vant'
import { Picker } from 'vant'

export default {
  name: 'videoD',
  components: {
    tabbar: tabbar
  },
  data () {
    return {
      classlist: [],
      isLogin: true, // 是否登录
      stuProgress: '10%',
      validHours: 10,
      basicHours: 200,
      dateEnd: '2019-10-30',
      payMoney: '140.00',
      userType: 0, // 用户类型  继续教育0  专项学习1
      needwsBox:false,
      cityList:[],
      yearTerm:'',
      hyTerm:0,
    }
  },
  computed: {
    ...mapGetters(['ProfessionId'])
  },
  created () {
    var userId = sessionStorage.getItem('userId')
    if (userId === '' || userId === null || userId === undefined) {
      this.isLogin = false
    } else {
      this.isLogin = true;
      // this.getTrainlists(5)
      this.$store.dispatch('SetPlatform', 0);
      this.$store.dispatch('SetProfessionId',5);
      sessionStorage.setItem('platform', 0);
      sessionStorage.setItem('professionId', 5);
      // this.companyList();
    }
  },
  mounted () {
    window.myVue = this
  },
  methods: {
      toPage(t){
        var pageUrl = "";
        if(t===0){
          pageUrl = "/cEdu";
        }
        if(t===2){
          pageUrl = "/rt";
        }
        if(t===1){
          pageUrl = "/spStudy";
        }
        if(t===3){
          pageUrl = "/sfStudy";
        }
        if(t===4){
          pageUrl = "/twoClass";
        }
        sessionStorage.setItem('platform', t) // 继续教育0  专项学习1
        this.$store.dispatch('SetPlatform', t)
        this.$router.push({
            path:pageUrl
        })
    },
    companyList:function(){
      var that = this;
      companyList().then(res => {
        Indicator.close();
        if (res.data.returnCode === 1) {
            var carr = res.data.returnDate;
            carr.forEach(element => {
              var co = {
                id:element.id,
                text:element.company_name
              }
              that.cityList.push(co);
            });
        } else {
          Toast(res.data.returnMsg)
        }
      })
    },
    onConfirm(picker, value, index){
      debugger;
      var that = this;
      that.needwsBox = false;
      var params = {
        companyId:picker.id
      }
      Indicator.open()
      perfect(params).then(res => {
        Indicator.close();
        if (res.data.returnCode === 1) {
            this.$router.push({ path: '/vGroup', query: { year: that.yearTerm,hyCode:that.hyTerm } })
        } else {
          Toast(res.data.returnMsg)
        }
      })
    },
    onCancel(){
      this.needwsBox = false;
      console.log('点击了取消按钮');
    },
    toStudy: function (obj) {
      let playType = 'mp4'
      if (playType === 'mp4' || playType === 'flv') {
        this.$router.push({ path: '/v', query: { videoObj: obj } })
      } else if (playType === 'pdf') {
        this.$router.push({ path: '/pdf', query: { videoObj: obj } })
      }
    },
    getTrainlists (t) {
      var type = 0;
      if (type === '' || type === undefined || type === null) {
        type = 0
      }
      Indicator.open()
      var _this = this
      console.log('行业' + sessionStorage.getItem('professionId'))
      getTrainlist({
        source: type,
        type: t
      }).then(res => {
        if (res.data.returnCode === 1) {
          Indicator.close()
          _this.classlist = res.data.returnDate
        } else {
          Indicator.close()
          Toast(res.data.returnMsg)
        }
      })
    },
    toCourseList (year,hyCode) {
      var that = this;
      if (
        sessionStorage.getItem('photo') === '' ||
        sessionStorage.getItem('photo') === null ||
        sessionStorage.getItem('photo') === undefined
      ) {
        Toast('未上传头像，无法学习！')
      } else {
        Indicator.open()
      //判断是否需要完善信息··
      needws().then(res => {
          Indicator.close()
        if (res.data.returnCode === 1) {
            var isBox  = res.data.returnDate;
            if(!isBox){
               this.$router.push({ path: '/vGroup', query: { year: year,hyCode:hyCode } })
            }else{
              //弹出完善信息界面
              that.needwsBox = res.data.returnDate;
              that.hyTerm = hyCode;
              that.yearTerm = year;
            }
        } else {
          Toast(res.data.returnMsg)
        }
      })

      
      }
    }
  },
  destroyed () {
    Indicator.close()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/TrainList.vue